import { useEffect, useState } from "react";
import { collection, query, where, getDocs, updateDoc, doc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { getAuth } from "firebase/auth";
import { Link } from "react-router-dom";
import html2canvas from "html2canvas";
import './MyPage.css'; // 
import { limit, orderBy } from "firebase/firestore"; //

function getPersonaLabel(key) {
  const map = {
    benevolent_sage: "慈愛の賢者",
    profound_thinker: "深淵の思想家",
    cheerful_jester: "陽気な道化師",
    zen_master: "禅の老師"
  };
  return map[key] || "語り口不明";
}

export default function MyPage() {
  const [posts, setPosts] = useState([]);
  const [user, setUser] = useState(null);
  const [showFavoritesOnly, setShowFavoritesOnly] = useState(false);
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        fetchPosts(currentUser.uid);
      }
    });
    return () => unsubscribe();
  }, []);

  const fetchPosts = async (uid) => {
  try {
    const q = query(
      collection(db, "posts"),
      where("uid", "==", uid),
      orderBy("createdAt", "desc"), // 新しい順に並べる
      limit(30) // 最大30件に制限
    );
    const snapshot = await getDocs(q);
    const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setPosts(data);
  } catch (error) {
    console.error("灯り取得失敗:", error);
  }
};

  const handleFavorite = async (postId) => {
    try {
      // UIを即時反映させるため、先にStateを更新
      setPosts(prev =>
        prev.map(p => (p.id === postId ? { ...p, isFavorite: true } : p))
      );
      // その後、データベースを更新
      await updateDoc(doc(db, "posts", postId), { isFavorite: true });
    } catch (error) {
      console.error("お気に入り登録失敗:", error);
      // エラーが発生した場合はStateを元に戻す
      setPosts(prev =>
        prev.map(p => (p.id === postId ? { ...p, isFavorite: false } : p))
      );
    }
  };

  const generateImage = async (postId) => {
    const element = document.getElementById(`share-image-${postId}`);
    if (!element) return;
    const canvas = await html2canvas(element, { scale: 2 }); // 高解像度化
    const dataUrl = canvas.toDataURL("image/png");

    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = "灯りの語り口.png";
    link.click();
  };

  const filteredPosts = showFavoritesOnly
    ? posts.filter((post) => post.isFavorite)
    : posts;

  return (
    <div className="my-page-container">
      <h2 className="page-title">
        灯主：{user?.displayName || "匿名"} さんのことばの灯り棚
      </h2>

      <div className="button-container">
        <button
          onClick={() => setShowFavoritesOnly(!showFavoritesOnly)}
          className="filter-button"
        >
          {showFavoritesOnly ? "すべて表示する" : "お気に入りだけ表示する"}
        </button>

        <Link to="/" className="back-link">
          変換ページへ戻る
        </Link>
      </div>

      {filteredPosts.length === 0 ? (
        <p className="no-posts-message">灯りが見つかりません。</p>
      ) : (
        filteredPosts.map((post) => {
          const shareText = `「${post.input}」→「${post.output}」 (${getPersonaLabel(post.persona)})`;
          const encodedText = encodeURIComponent(shareText);
          const twitterUrl = `https://twitter.com/intent/tweet?text=${encodedText}`;
          const lineUrl = `https://social-plugins.line.me/lineit/share?text=${encodedText}`;

          return (
            <div key={post.id} className="post-card">
              <p className="post-input">「{post.input}」</p>
              <p>↓</p>
              <p>{post.output}</p>
              <p className="post-persona">（{getPersonaLabel(post.persona)}）</p>

              {!post.isFavorite ? (
                <button
                  onClick={() => handleFavorite(post.id)}
                  className="favorite-button"
                >
                  この灯りをお気に入りに追加
                </button>
              ) : (
                <p className="favorited-message">お気に入り済み 🌟</p>
              )}

              <div className="share-buttons">
                <a href={twitterUrl} target="_blank" rel="noopener noreferrer" className="share-button share-twitter">
                  Xで共有
                </a>
                <a href={lineUrl} target="_blank" rel="noopener noreferrer" className="share-button share-line">
                  LINEで共有
                </a>
                <button
                  onClick={() => generateImage(post.id)}
                  className="share-button share-instagram"
                >
                  Instagram用画像をDL
                </button>
              </div>

              {/* ↓↓ html2canvasで画像生成するための非表示要素 ↓↓ */}
              <div id={`share-image-${post.id}`} className="share-image-wrapper">
                <h2>ことばのゆるしかた</h2>
                <p className="post-input">「{post.input}」</p>
                <p>↓</p>
                <p className="post-output">「{post.output}」</p>
                <p className="post-persona">（{getPersonaLabel(post.persona)}）</p>
                <p className="footer-text">
                  https://kotobano-yurusikata.web.app
                </p>
                <p className="footer-hashtag">
                  #ことばのゆるしかた #灯主の語り口 #言葉の供養
                </p>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}